import { FbmakeStyles } from "@flexibees/core";
import { COLORS } from "../constants/colors";

export const useStyles = FbmakeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  contentHeader: {
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
  },
  contentBody: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    width: "70vw",
  },
  textTransform_none: {
    textTransform: "none",
    padding: 0,
  },
  tags: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "5px 0",
    // paddingRight: 15,
  },
  addConfigButton: {
    marginRight: 20,
  },
  marginTop_25: {
    marginTop: 10,
  },
  marginRight_20: {
    marginRight: 20,
  },
  tableContainer: {},
  marginHorizontal_20: {
    marginLeft: 20,
    marginRight: 20,
  },
  spacing: {
    marginRight: 20,
    width: 200,
    textTransform: "none",
  },
  skillToolTipBox: {
    borderRadius: 0,
    margin: theme.spacing(1),
    borderWidth: 0,
  },
  skillslist: {
    maxHeight: 200,
    overflow: "auto",
  },
  linkButton: {
    color: COLORS.LINK,
    fontWeight: "500",
    fontSize: 13,
    textDecoration: "underline",
    marginRight: 10,
    cursor: "pointer",
  },
  rowTitle: {
    color: COLORS.SUBTEXT,
  },
}));

export const useListStyles = FbmakeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  contentHeader: {
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
  },
  contentBody: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    width: "70vw",
    marginTop:24
  },
  textTransform_none: {
    textTransform: "none",
    padding: 0,
  },
  tags: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "5px 0",
    // paddingRight: 15,
  },
  addConfigButton: {
    marginRight: 20,
  },
  marginTop_25: {
    marginTop: 10,
  },
  marginRight_20: {
    marginRight: 20,
  },
  tableContainer: {},
  marginHorizontal_20: {
    marginLeft: 20,
    marginRight: 20,
  },
  spacing: {
    marginRight: 20,
    width: 200,
    textTransform: "none",
  },
  skillToolTipBox: {
    borderRadius: 0,
    margin: theme.spacing(1),
    borderWidth: 0,
  },
  skillslist: {
    maxHeight: 200,
    overflow: "auto",
  },
  linkButton: {
    color: COLORS.LINK,
    fontWeight: "500",
    fontSize: 13,
    textDecoration: "underline",
    marginRight: 10,
    cursor: "pointer",
  },
  rowTitle: {
    color: COLORS.SUBTEXT,
  },
}));

export const useStylesForm = FbmakeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    width: 560,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  button: {
    width: "100%",
    padding: 10,
  },
  row: {
    marginBottom: 20,
  },
}));

export const useConfigStyle = FbmakeStyles((theme) => ({
  contentHeader: {
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
  },
  contentBody: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
  },
  textTransform_none: {
    textTransform: "none",
  },
  tags: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  addConfigButton: {
    marginRight: 20,
  },
  marginTop_25: {
    marginTop: 25,
  },
  marginRight_20: {
    marginRight: 20,
  },
  subtextColor: {
    color: COLORS.SUBTEXT,
  },
  tableContainer: {},
  marginHorizontal_20: {
    marginLeft: 20,
    marginRight: 20,
  },
  rowTitle: {
    color: COLORS.SUBTEXT,
  },
}));

export const useAddActivity = FbmakeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    width: 560,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  button: {
    width: "100%",
    padding: 10,
  },
  row: {
    marginBottom: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  dropdownContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    marginBottom: 20,
  },
  addMoreSessions: {
    width: "10%",
    display: "inline-block",
    textAlign: "center",
    marginLeft: 10,
    // marginTop: 10,
  },
}));

export const useDialog = FbmakeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(5),
    width: 380,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  button: {
    width: "100%",
    padding: 10,
  },
  image: {
    width: "50%",
  },
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
}));

export const useAvalibiltyStyle = FbmakeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  contentBody: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  textTransform_none: {
    textTransform: "none",
    padding: 0,
  },
  tags: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "5px 0",
    width: "auto",
  },
  spacing: {
    marginRight: 20,
    width: 200,
    textTransform: "none",
  },
  skillToolTipBox: {
    padding: 10,
    border: "none",
    textAlign: "left",
  },
}));